export default "__VITE_ASSET__C$3zL7kX__"